import { pageTheme } from './pageTheme.esm.js';

const DEFAULT_HTML_FONT_SIZE = 16;
const DEFAULT_FONT_FAMILY = '"Helvetica Neue", Helvetica, Roboto, Arial, sans-serif';
const DEFAULT_PAGE_THEME = "home";
const defaultTypography = {
  htmlFontSize: DEFAULT_HTML_FONT_SIZE,
  fontFamily: DEFAULT_FONT_FAMILY,
  h1: {
    fontSize: 54,
    fontWeight: 700,
    marginBottom: 10
  },
  h2: {
    fontSize: 40,
    fontWeight: 700,
    marginBottom: 8
  },
  h3: {
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 6
  },
  h4: {
    fontWeight: 700,
    fontSize: 28,
    marginBottom: 6
  },
  h5: {
    fontWeight: 700,
    fontSize: 24,
    marginBottom: 4
  },
  h6: {
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 2
  }
};
function createBaseThemeOptions(options) {
  const {
    palette,
    htmlFontSize = DEFAULT_HTML_FONT_SIZE,
    fontFamily = DEFAULT_FONT_FAMILY,
    defaultPageTheme = DEFAULT_PAGE_THEME,
    pageTheme: pageTheme$1 = pageTheme,
    typography
  } = options;
  if (!pageTheme$1[defaultPageTheme]) {
    throw new Error(`${defaultPageTheme} is not defined in pageTheme.`);
  }
  defaultTypography.htmlFontSize = htmlFontSize;
  defaultTypography.fontFamily = fontFamily;
  return {
    palette,
    typography: typography ?? defaultTypography,
    page: pageTheme$1[defaultPageTheme],
    getPageTheme: ({ themeId }) => pageTheme$1[themeId] ?? pageTheme$1[defaultPageTheme]
  };
}

export { createBaseThemeOptions, defaultTypography };
//# sourceMappingURL=createBaseThemeOptions.esm.js.map
